import React, { useState } from "react";
import Tooltip from "@amzn/meridian/tooltip";
import { Button, Icon } from "@amzn/meridian";
import { useAppDispatch, useAppSelector } from "src/store/store";
import { createToast } from "src/store/toastsSlice";
import { TOAST_TIMEOUT } from "src/constants/constants";
import saveTokens from "@amzn/meridian-tokens/base/icon/save";
import "./favoriteToggleButton.scss";
import ChatService from "../../service/chatService";
import { setAllFavoriteMessages } from "../../store/chatSlice";

interface FavoriteToggleButtonProps {
  messageId: string;
}

const FavoriteToggleButton = ({ messageId }: FavoriteToggleButtonProps) => {
  const { favoriteMessages } = useAppSelector((state) => state.chatSlice);

  const dispatch = useAppDispatch();
  const [isHovering, setIsHovering] = useState(false);

  const isFavoriteSelected = favoriteMessages.some(
    (msg) => msg.messageId === messageId,
  );

  const showErrorToast = (message: string) => {
    dispatch(
      createToast({
        type: "error",
        message: message,
        timeout: TOAST_TIMEOUT,
      }),
    );
  };

  //get all recent favorites of an user
  const getAllRecentFavorites = async () => {
    try {
      const userFavoriteMessages = await ChatService.getAllFavorites();
      dispatch(setAllFavoriteMessages(userFavoriteMessages));
    } catch (error) {
      showErrorToast("Failed to fetch favorites list");
    }
  };

  const handleToggleFavorite = async () => {
    try {
      let response;
      /*
      if isFavoritedSelected is true, this indicates an un-favorite action,
      so remove it from the list. Otherwise, we add it to the favorites.
      */

      if (isFavoriteSelected) {
        response = await ChatService.removeFavorite(messageId);
      } else {
        response = await ChatService.addFavorite(messageId);
      }

      if (response.data.successful) {
        setIsHovering(false);
        getAllRecentFavorites(); // Fetch and update the recent favorites list
      }
    } catch (error) {
      showErrorToast(
        `Failed to ${isFavoriteSelected ? "remove from saved queries" : "save this query"}`,
      );
    }
  };

  return (
    <Tooltip
      position="end"
      title={isFavoriteSelected ? "Remove saved query" : "Save this query"}
      open={isHovering}
    >
      <Button
        type="icon"
        onClick={handleToggleFavorite}
        onMouseEnter={() => setIsHovering(true)}
        onMouseLeave={() => setIsHovering(false)}
        className="favorite-star-button"
      >
        <Icon
          color={isFavoriteSelected ? "success" : "secondary"}
          tokens={saveTokens}
        />
      </Button>
    </Tooltip>
  );
};

export default FavoriteToggleButton;
